import { getLogger } from '../logging/logger';
import PopUp from '../popup';
import InputManager from './inputManager';

const logger = getLogger('PopUpManager');

class PopUpManager {
	constructor() {
		logger.log('[initialize]');

		InputManager.add('popup', {
			selector: '#popup-overlay button',
			restrict: 'self-only',
		});

		this.activePopUp = undefined;
		this.queue = [];
	}

	get isDisplayed() {
		logger.log('[isDisplayed]');
		return !!this.activePopUp;
	}

	/**
	 * Displays or queues a new pop up to be displayed to the user
	 * @param {Object | string} popUpData Either a string to be displayed or an object that must
	 * contain 'message' or 'contentHtml' properties and optionally can provided Backbone View Events
	 * object for handling mutliple buttons.
	 * @param {string} [title] The title to be displayed. Can also be passed in as part of the popUpData.
	 * @returns Returns the new pop up created for reference
	 */
	displayPopUp(popUpData, title) {
		logger.log('[displayPopUp]', { popUpData, title });

		let data = { events: { 'click button': () => this.nextPopUp() }, ...popUpData };
		if (typeof popUpData === 'string') {
			data = { title, message: popUpData };
		}

		const newPopUp = new PopUp(data);
		this.queue.push(newPopUp);

		if (!this.activePopUp) {
			this.nextPopUp();
		}

		return newPopUp;
	}

	nextPopUp() {
		logger.log('[nextPopUp]');

		const prevPopUp = this.activePopUp;
		this.activePopUp = this.queue.shift();

		return Promise.resolve()
			.then(() => prevPopUp?.close())
			.then(() =>
				this.activePopUp?.open().then(() => this.activePopUp.$el.find('.btn').focus()),
			);
	}

	dismissActivePopUp() {
		logger.log('[dismissActivePopUp]', { activePopup: this.activePopUp });

		if (this.activePopUp) {
			return this.activePopUp.close().then(() => {
				this.activePopUp.destroy();
				this.activePopUp = undefined;
			});
		}

		return Promise.resolve();
	}
}

export default new PopUpManager();
